import React from "react";
import "./Home.css";

function SwivelSeat() {
  return (
    <div className="home-section-container">
      <div className="home-content-split">
        <div className="home-text-content">
          <div className="title-text-cont">
            <h1>SWIVEL SEAT</h1>
            <p className="home-subtitle">
              <img className="brandImg" src="/swivel.avif" />
              <br />Scopema Swivel Seat
            </p>
          </div>
        </div>

        <div className="home-image-content">
          <iframe src="https://drive.google.com/file/d/1li3dstdyhShuanzh7-KY_sTKxHvEhOAA/preview"></iframe>
        </div>
      </div>

      <div className="outdoorsy-container" style={{ textAlign: "left" }}>
        <p className="tealText">
          To operate the swivel seat, pull the red lever at the base of the passenger seat to the right (towards the center of the van).
        </p>
        <p className="tealText">
          The seat will turn about ¾ of the way and stop. Pull the lever again to continue rotating the seat 180 degrees.
        </p>
        <p className="tealText">
          You’ll need to use some force, the seat is bulky and heavy!
        </p>
      </div>

      <div className="movCont">
        <img src="/seat.jpg" className="home-image" />
      </div>
    </div>
  );
}

export default SwivelSeat;
